<template>
    <div>
        <Header :title="title"></Header>
        <DetailTitle :info="detailInfo"></DetailTitle>
        <Chart :rateList="rateList"></Chart>
        <DetailBody :info="detailInfo"></DetailBody>
        <Bottom_comp></Bottom_comp>
        <Footer></Footer>
    </div>

</template>

<script>
    import Header from '@/components/Header.vue'
    import DetailTitle from '@/components/project/DetailTitle.vue'
    import Chart from '@/components/project/Chart.vue'
    import DetailBody from '@/components/project/DetailBody.vue'
    import Footer from '@/components/Footer.vue'
    import Bottom_comp from '@/components/Bottom_comp.vue'
    import {getReq} from "../utils/api";
    export default {
        name: "Details",
        data(){
          return{
              title:this.$t('details.pagetitle'),
              rateList:[],
              detailInfo: {}
          }
        },
        mounted(){
            this.getDetails()
        },
        methods:{
            getDetails(){
                getReq('/getDetailDate',{
                    id:this.$route.query.id
                }).then((res)=>{
                    if(res.code==200){
                        this.rateList = res.data.rateList;
                        this.detailInfo = res.data;
                    }
                })
            }
        },
        components:{
            Header,
            DetailTitle,
            Chart,
            DetailBody,
            Footer,
            Bottom_comp
        }
    }
</script>

<style scoped lang="scss">

</style>
